import { render, staticRenderFns } from "./facilities.vue?vue&type=template&id=5942d5f1&scoped=true&"
import script from "./facilities.vue?vue&type=script&lang=ts&"
export * from "./facilities.vue?vue&type=script&lang=ts&"
import style0 from "./facilities.vue?vue&type=style&index=0&id=5942d5f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942d5f1",
  null
  
)

export default component.exports